module.exports = __webpack_public_path__ + "holidu-logo.png?5e97aeae5c0e3c7c57bbb5de656e04b1";